/* ============================================================
   DTF-OPTIONEN · Lieblingscap
   Positionen, Druckgroesse, Datei-Upload und Live-Fotovorschau.
   Die Fotodaten werden aus der bereits gerenderten Stickerei-/
   Wunschlogo-Karte gelesen. Dadurch verwendet DTF exakt dieselben
   Taschenfotos, Farbvarianten und massstaeblichen Ankerpunkte.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('dtf-optionen');
  if (!root || root.dataset.dtfInit) return;
  root.dataset.dtfInit = '1';

  var CFG = JSON.parse(root.dataset.config);
  var ORDER = ['vorne', 'hinten', 'links', 'rechts'];
  var AKTIV = ORDER.filter(function (p) { return CFG.positionen.indexOf(p) !== -1; });

  var FOTO_CFG = {};
  var fotoQuelle = document.getElementById('stickerei-karte') || document.getElementById('wunschlogo-karte');
  if (fotoQuelle) {
    try { FOTO_CFG = JSON.parse(fotoQuelle.dataset.config) || {}; } catch (e) { FOTO_CFG = {}; }
  }
  var IST_TASCHE = FOTO_CFG.stickTyp === 'tasche';
  var TASCHEN_DTF_REAL = { breite: 60, hoehe: 25 };
  var TASCHEN_DTF_FOTO = { breite: 41, hoehe: 21 };
  if (IST_TASCHE && CFG.flaechen && CFG.flaechen.vorne) {
    CFG.flaechen.vorne.w = TASCHEN_DTF_REAL.breite;
    CFG.flaechen.vorne.h = TASCHEN_DTF_REAL.hoehe;
  }

  var state = {
    gewaehlt: {},
    groessen: {},
    hatDatei: false,
    vorschauBereit: false,
    vorschauSrc: '',
    vorschauVerhaeltnis: 1,
    istPdf: false
  };
  AKTIV.forEach(function (p, i) {
    state.gewaehlt[p] = (i === 0);
    var a = CFG.flaechen[p];
    state.groessen[p] = { breite: a.w, hoehe: a.h };
  });

  var el = {
    zone: document.getElementById('dtf-zone'),
    datei: document.getElementById('dtf-datei'),
    name: document.getElementById('dtf-name'),
    info: document.getElementById('dtf-info'),
    knopf: document.getElementById('dtf-knopf'),
    positionen: document.getElementById('dtf-positionen'),
    preiszeile: document.getElementById('dtf-preiszeile'),
    groessen: document.getElementById('dtf-groessen'),
    props: document.getElementById('dtf-props'),
    blocker: document.getElementById('dtf-blocker')
  };
  var mengenEingabe = document.querySelector('.product-form__quantity input[name="quantity"]');
  var mengenHinweis = mengenEingabe && mengenEingabe.closest('.product-form__quantity')
    ? mengenEingabe.closest('.product-form__quantity').querySelector('p.caption')
    : null;
  var basisMindestmenge = mengenEingabe
    ? (parseInt(mengenEingabe.getAttribute('min') || mengenEingabe.dataset.min, 10) || 1)
    : 1;

  function k(n) { return n.toFixed(1).replace('.', ','); }
  function anzahl() { return AKTIV.filter(function (p) { return state.gewaehlt[p]; }).length; }
  function aktivesPanel() {
    var panel = root.closest('.va-panel');
    return !(panel && panel.hidden);
  }

  function aktualisiereMindestmenge() {
    if (!IST_TASCHE || !mengenEingabe) return;
    var dtfAktiv = aktivesPanel();
    var minimum = dtfAktiv ? 15 : basisMindestmenge;
    mengenEingabe.min = minimum;
    mengenEingabe.dataset.min = minimum;
    if (mengenHinweis) mengenHinweis.textContent = 'Mindestens ' + minimum + ' Stück';

    var wert = parseInt(mengenEingabe.value, 10);
    if (!Number.isFinite(wert) || wert < minimum) {
      mengenEingabe.value = minimum;
      feuere(mengenEingabe);
      return false;
    }
    return true;
  }

  function aktuelleFarbe() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return CFG.farbeAktuell;
    var gruppe = vs.querySelector('fieldset, .product-form__input--dropdown');
    if (!gruppe) return CFG.farbeAktuell;
    var gewaehlt = gruppe.querySelector('input:checked') || gruppe.querySelector('select');
    return gewaehlt ? gewaehlt.value : CFG.farbeAktuell;
  }

  function fotoFuer(p) {
    var foto = FOTO_CFG.fotos && FOTO_CFG.fotos[p];
    if (!foto) return null;
    var src = foto.src;
    if (p === 'vorne' && FOTO_CFG.farbFotos && FOTO_CFG.farbFotos[CFG.farbeAktuell]) {
      src = FOTO_CFG.farbFotos[CFG.farbeAktuell];
    }
    return {
      src: src,
      cmWide: foto.cmWide,
      ratio: foto.ratio || 1,
      cx: foto.cx === undefined ? 0.5 : foto.cx,
      cy: foto.cy === undefined ? 0.5 : foto.cy,
      liftCm: foto.liftCm || 0,
      spiegeln: foto.spiegeln
    };
  }

  /* ---------- Preise + Variante ---------- */
  var geld = null;
  try {
    geld = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: 'EUR' });
  } catch (e) { geld = null; }
  function preisText(cent) {
    if (cent === null || cent === undefined) return '';
    var betrag = cent / 100;
    return geld ? geld.format(betrag) : betrag.toFixed(2).replace('.', ',') + ' €';
  }
  function stufenWert(n) {
    if (n === undefined) n = anzahl();
    var erwartet = n === 1 ? '1 Position' : n + ' Positionen';
    var stufen = CFG.stufen || [];
    if (stufen.indexOf(erwartet) !== -1) return erwartet;
    if (stufen.length >= n) return stufen[n - 1];
    return erwartet;
  }
  function preisFuer(n) {
    var v = CFG.varianten[CFG.farbeAktuell + '|' + stufenWert(n)];
    return v ? v.preis : null;
  }
  function feuere(e) {
    e.dispatchEvent(new Event('change', { bubbles: true }));
    e.dispatchEvent(new Event('input', { bubbles: true }));
  }
  function varianteSetzen() {
    var wert = stufenWert();
    var treffer = false;
    document.querySelectorAll(
      'variant-selects input[type=radio], variant-radios input[type=radio], .product-form__input input[type=radio]'
    ).forEach(function (i) {
      if (i.value === wert) { treffer = true; if (!i.checked) { i.checked = true; feuere(i); } }
    });
    if (!treffer) {
      document.querySelectorAll('variant-selects select, .product-form__input select').forEach(function (s) {
        for (var i = 0; i < s.options.length; i++) {
          if (s.options[i].value === wert) { treffer = true; if (s.value !== wert) { s.value = wert; feuere(s); } }
        }
      });
    }
    if (!treffer) {
      var v = CFG.varianten[CFG.farbeAktuell + '|' + wert];
      if (!v) return;
      var id = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (id) { id.value = v.id; feuere(id); }
    }
  }

  /* ---------- Positions-Kacheln ---------- */
  function zeichnePositionen() {
    el.positionen.innerHTML = '';
    el.positionen.style.gridTemplateColumns = 'repeat(' + Math.min(AKTIV.length, 4) + ',1fr)';
    var jetzt = preisFuer(anzahl());
    var mehr = preisFuer(anzahl() + 1);
    var aufschlag = (jetzt !== null && mehr !== null) ? mehr - jetzt : null;

    AKTIV.forEach(function (p) {
      var a = CFG.flaechen[p];
      var an = state.gewaehlt[p];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dtf__kachel';
      b.setAttribute('aria-pressed', an);
      var zusatz = '';
      if (!an && aufschlag !== null && aufschlag > 0) {
        zusatz = '<span class="dtf__kachel-plus">+ ' + preisText(aufschlag) + '</span>';
      }
      b.innerHTML = '<span class="dtf__kachel-name">' + a.kurz + '</span>' +
        '<span class="dtf__kachel-mass">max. ' + a.w + '×' + k(a.h) + ' cm</span>' + zusatz;
      b.addEventListener('click', function () {
        if (state.gewaehlt[p] && anzahl() === 1) return;
        state.gewaehlt[p] = !state.gewaehlt[p];
        varianteSetzen();
        alles();
      });
      el.positionen.appendChild(b);
    });

    var n = anzahl();
    var text = n === 1 ? '1 Position' : n + ' Positionen';
    el.preiszeile.innerHTML = jetzt !== null
      ? '<strong>' + text + '</strong> · <span class="dtf__preis">' + preisText(jetzt) + '</span>'
      : 'Der Preis richtet sich nach der Anzahl der Positionen.';
  }

  /* ---------- Vorschau ---------- */
  function baueVorschau(p) {
    var preview = document.createElement('div');
    preview.className = 'dtf__preview';
    preview.dataset.position = p;
    preview.setAttribute('aria-label', 'Vorschau für ' + CFG.flaechen[p].label);

    var feld = document.createElement('div');
    feld.className = 'dtf__preview-field';
    feld.setAttribute('aria-label', 'Feste Druckfläche ' + CFG.flaechen[p].w + ' × ' + k(CFG.flaechen[p].h) + ' cm');
    var designBox = document.createElement('div');
    designBox.className = 'dtf__preview-design-box';
    designBox.hidden = true;
    var bild = document.createElement('img');
    bild.className = 'dtf__preview-design';
    bild.alt = 'Vorschau des hochgeladenen Designs';
    var griff = document.createElement('button');
    griff.type = 'button';
    griff.className = 'dtf__resize-handle';
    griff.setAttribute('aria-label', 'Motivgröße durch Ziehen ändern');
    griff.title = 'Ziehen, um die Motivgröße zu ändern';
    griff.innerHTML = '<span aria-hidden="true">↘</span>';
    var leer = document.createElement('span');
    leer.className = 'dtf__preview-empty';
    leer.textContent = 'Design hochladen';
    designBox.appendChild(bild);
    designBox.appendChild(griff);
    feld.appendChild(designBox);
    feld.appendChild(leer);
    preview.appendChild(feld);
    aktiviereGroessenGriff(preview);
    return preview;
  }

  function aktualisiereVorschau(preview) {
    var p = preview.dataset.position;
    var a = CFG.flaechen[p];
    var s = state.groessen[p];
    var foto = fotoFuer(p);
    var feld = preview.querySelector('.dtf__preview-field');
    var designBox = preview.querySelector('.dtf__preview-design-box');
    var bild = preview.querySelector('.dtf__preview-design');
    var leer = preview.querySelector('.dtf__preview-empty');

    if (foto && foto.src && foto.cmWide) {
      preview.classList.add('dtf__preview--photo');
      preview.classList.toggle('dtf__preview--flip', Boolean(foto.spiegeln));
      preview.style.aspectRatio = foto.ratio;
      preview.style.backgroundImage = 'url("' + foto.src + '")';
      var cmHoch = foto.cmWide / foto.ratio;
      var lift = foto.liftCm / cmHoch;
      var fotoBreite = a.w;
      var fotoHoehe = a.h;
      if (IST_TASCHE && p === 'vorne') {
        fotoBreite *= TASCHEN_DTF_FOTO.breite / TASCHEN_DTF_REAL.breite;
        fotoHoehe *= TASCHEN_DTF_FOTO.hoehe / TASCHEN_DTF_REAL.hoehe;
      }
      feld.style.width = (fotoBreite / foto.cmWide * 100) + '%';
      feld.style.height = (fotoHoehe / cmHoch * 100) + '%';
      feld.style.left = (foto.cx * 100) + '%';
      feld.style.top = ((foto.cy - lift) * 100) + '%';
    } else {
      preview.classList.remove('dtf__preview--photo', 'dtf__preview--flip');
      preview.style.aspectRatio = a.w + ' / ' + a.h;
      preview.style.backgroundImage = '';
      feld.style.width = '100%';
      feld.style.height = '100%';
      feld.style.left = '50%';
      feld.style.top = '50%';
    }

    designBox.style.width = (s.breite / a.w * 100) + '%';
    designBox.style.height = (s.hoehe / a.h * 100) + '%';

    if (state.vorschauBereit && state.vorschauSrc) {
      bild.src = state.vorschauSrc;
      bild.hidden = false;
      designBox.hidden = false;
      leer.hidden = true;
    } else {
      bild.removeAttribute('src');
      bild.hidden = true;
      designBox.hidden = true;
      leer.hidden = false;
      leer.textContent = state.hatDatei ? 'Vorschau wird erstellt …' : 'Design hochladen';
    }
  }

  function aktualisiereVorschauen(ohneGalerie) {
    root.querySelectorAll('.dtf__preview').forEach(aktualisiereVorschau);
    if (!ohneGalerie && galleryVorschau) galleryVorschau.sync();
  }

  function rundeMass(wert) {
    return Math.round(wert * 10) / 10;
  }

  function aktualisiereGroessenfelder(p) {
    var box = el.groessen.querySelector('.dtf__groesse-block[data-position="' + p + '"]');
    if (!box) return;
    var breite = box.querySelector('[data-dtf-dimension="breite"]');
    var hoehe = box.querySelector('[data-dtf-dimension="hoehe"]');
    if (breite) breite.value = state.groessen[p].breite;
    if (hoehe) hoehe.value = state.groessen[p].hoehe;
  }

  function setzeMotivGroesse(p, breite, hoehe, dragPreview) {
    var a = CFG.flaechen[p];
    var s = state.groessen[p];
    s.breite = rundeMass(Math.min(a.w, Math.max(1, breite)));
    s.hoehe = rundeMass(Math.min(a.h, Math.max(1, hoehe)));
    aktualisiereGroessenfelder(p);
    schreibeProperties();
    aktualisiereVorschauen(true);
    if (dragPreview && !root.contains(dragPreview)) aktualisiereVorschau(dragPreview);
    pruefe();
  }

  function aktiviereGroessenGriff(preview) {
    var griff = preview.querySelector('.dtf__resize-handle');
    if (!griff || griff.dataset.dtfGriffInit) return;
    griff.dataset.dtfGriffInit = '1';
    griff.addEventListener('pointerdown', function (start) {
      if (!state.vorschauBereit) return;
      start.preventDefault();
      start.stopPropagation();
      var p = preview.dataset.position;
      var a = CFG.flaechen[p];
      var feld = preview.querySelector('.dtf__preview-field');
      var verhaeltnis = state.vorschauVerhaeltnis || (state.groessen[p].breite / state.groessen[p].hoehe) || 1;
      preview.classList.add('dtf__preview--resizing');
      if (griff.setPointerCapture) griff.setPointerCapture(start.pointerId);

      function bewegen(e) {
        var rect = feld.getBoundingClientRect();
        if (!rect.width) return;
        var mitteX = rect.left + rect.width / 2;
        var breite = Math.abs(e.clientX - mitteX) * 2 / rect.width * a.w;
        breite = Math.min(a.w, Math.max(1, breite));
        var hoehe = breite / verhaeltnis;
        if (hoehe > a.h) {
          hoehe = a.h;
          breite = hoehe * verhaeltnis;
        }
        setzeMotivGroesse(p, breite, hoehe, preview);
      }

      function ende() {
        preview.classList.remove('dtf__preview--resizing');
        griff.removeEventListener('pointermove', bewegen);
        griff.removeEventListener('pointerup', ende);
        griff.removeEventListener('pointercancel', ende);
        aktualisiereVorschauen();
      }

      griff.addEventListener('pointermove', bewegen);
      griff.addEventListener('pointerup', ende);
      griff.addEventListener('pointercancel', ende);
    });
  }

  function passeMotivAnDateiAn() {
    var verhaeltnis = state.vorschauVerhaeltnis || 1;
    AKTIV.filter(function (p) { return state.gewaehlt[p]; }).forEach(function (p) {
      var a = CFG.flaechen[p];
      var breite = a.w;
      var hoehe = breite / verhaeltnis;
      if (hoehe > a.h) {
        hoehe = a.h;
        breite = hoehe * verhaeltnis;
      }
      state.groessen[p].breite = rundeMass(breite);
      state.groessen[p].hoehe = rundeMass(hoehe);
    });
    zeichneGroessen();
    schreibeProperties();
  }

  /* ---------- Groessenfelder je gewaehlter Position ---------- */
  function zeichneGroessen() {
    el.groessen.innerHTML = '';
    AKTIV.filter(function (p) { return state.gewaehlt[p]; }).forEach(function (p) {
      var a = CFG.flaechen[p];
      var s = state.groessen[p];

      var box = document.createElement('div');
      box.className = 'dtf__groesse-block';
      box.dataset.position = p;
      var h = document.createElement('h4');
      h.innerHTML = a.label + ' <span class="dtf__dim">feste Druckfläche ' + a.w + ' × ' + k(a.h) + ' cm</span>';
      box.appendChild(h);

      var row = document.createElement('div');
      row.className = 'dtf__groesse-row';

      function feldGroesse(dimension, labelText, wert, max, onInput) {
        var label = document.createElement('label');
        label.className = 'dtf__feld-klein';
        var span = document.createElement('span');
        span.textContent = labelText;
        var input = document.createElement('input');
        input.type = 'number';
        input.step = '0.5';
        input.min = '1';
        input.max = max;
        input.value = wert;
        input.dataset.dtfDimension = dimension;
        input.addEventListener('input', onInput);
        label.appendChild(span);
        label.appendChild(input);
        return label;
      }

      row.appendChild(feldGroesse('breite', 'Logo-Breite in cm', s.breite, a.w, function (e) {
        s.breite = Math.min(a.w, Math.max(1, parseFloat(e.target.value) || 1));
        schreibeProperties();
        aktualisiereVorschauen();
        pruefe();
      }));
      row.appendChild(feldGroesse('hoehe', 'Logo-Höhe in cm', s.hoehe, a.h, function (e) {
        s.hoehe = Math.min(a.h, Math.max(1, parseFloat(e.target.value) || 1));
        schreibeProperties();
        aktualisiereVorschauen();
        pruefe();
      }));

      box.appendChild(row);
      var hilfe = document.createElement('p');
      hilfe.className = 'dtf__resize-hint';
      hilfe.textContent = 'Logo am orangefarbenen Griff proportional ziehen oder Wunschmaß exakt eingeben.';
      box.appendChild(hilfe);
      var titel = document.createElement('p');
      titel.className = 'dtf__preview-label';
      titel.textContent = 'Live-Vorschau · Druckfläche ' + a.w + ' × ' + k(a.h) + ' cm';
      box.appendChild(titel);
      box.appendChild(baueVorschau(p));
      el.groessen.appendChild(box);
    });
    aktualisiereVorschauen();
  }

  /* ---------- Datei ---------- */
  function ladePdfJs() {
    return new Promise(function (loesen, ablehnen) {
      if (window.pdfjsLib) return loesen(window.pdfjsLib);
      var vorhanden = document.querySelector('script[data-dtf-pdfjs]');
      if (vorhanden) {
        vorhanden.addEventListener('load', function () { loesen(window.pdfjsLib); }, { once: true });
        vorhanden.addEventListener('error', ablehnen, { once: true });
        return;
      }
      var script = document.createElement('script');
      script.dataset.dtfPdfjs = '1';
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
      script.onload = function () {
        try {
          window.pdfjsLib.GlobalWorkerOptions.workerSrc =
            'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
        } catch (e) {}
        loesen(window.pdfjsLib);
      };
      script.onerror = ablehnen;
      document.head.appendChild(script);
    });
  }

  function verarbeitePdf(datei) {
    ladePdfJs().then(function (lib) {
      return datei.arrayBuffer().then(function (puffer) {
        return lib.getDocument({ data: puffer }).promise;
      });
    }).then(function (pdf) {
      return pdf.getPage(1);
    }).then(function (seite) {
      var basis = seite.getViewport({ scale: 1 });
      var sicht = seite.getViewport({ scale: 900 / basis.width });
      var canvas = document.createElement('canvas');
      canvas.width = sicht.width;
      canvas.height = sicht.height;
      return seite.render({ canvasContext: canvas.getContext('2d'), viewport: sicht }).promise
        .then(function () { return canvas; });
    }).then(function (canvas) {
      state.vorschauSrc = canvas.toDataURL('image/png');
      state.vorschauVerhaeltnis = canvas.width / canvas.height || 1;
      state.vorschauBereit = true;
      el.info.textContent = 'PDF · erste Seite in der Vorschau';
      passeMotivAnDateiAn();
    }).catch(function () {
      state.vorschauBereit = false;
      el.info.textContent = 'PDF wird mitgeschickt · Vorschau konnte nicht erstellt werden';
      aktualisiereVorschauen();
    });
  }

  function verarbeiteBild(datei) {
    var leser = new FileReader();
    leser.onload = function (ev) {
      var bild = new Image();
      bild.onload = function () {
        state.vorschauSrc = ev.target.result;
        state.vorschauVerhaeltnis = bild.naturalWidth / bild.naturalHeight || 1;
        state.vorschauBereit = true;
        el.info.textContent = bild.naturalWidth + ' × ' + bild.naturalHeight + ' px · Vorschau aktiv';
        passeMotivAnDateiAn();
      };
      bild.onerror = function () {
        state.vorschauBereit = false;
        el.info.textContent = 'Datei wird mitgeschickt · Vorschau konnte nicht erstellt werden';
        aktualisiereVorschauen();
      };
      bild.src = ev.target.result;
    };
    leser.readAsDataURL(datei);
  }

  el.zone.addEventListener('click', function () { el.datei.click(); });
  el.datei.addEventListener('change', function (e) {
    var f = e.target.files && e.target.files[0];
    if (!f) return;
    state.hatDatei = true;
    state.vorschauBereit = false;
    state.vorschauSrc = '';
    state.istPdf = /\.pdf$/i.test(f.name) || f.type === 'application/pdf';
    el.zone.classList.add('ist-bereit');
    el.name.textContent = f.name;
    el.knopf.textContent = 'Ändern';
    el.info.textContent = 'Vorschau wird erstellt …';
    alles();
    if (state.istPdf) verarbeitePdf(f);
    else verarbeiteBild(f);
  });

  /* ---------- Properties + Pruefung ---------- */
  function feld(name, wert) {
    var i = document.createElement('input');
    i.type = 'hidden';
    i.name = 'properties[' + name + ']';
    i.value = wert;
    el.props.appendChild(i);
  }
  function schreibeProperties() {
    el.props.innerHTML = '';
    var gewaehlte = AKTIV.filter(function (p) { return state.gewaehlt[p]; });
    feld('Druckpositionen', gewaehlte.map(function (p) { return CFG.flaechen[p].kurz; }).join(' + '));
    gewaehlte.forEach(function (p) {
      var s = state.groessen[p];
      feld(CFG.flaechen[p].label + ' — Logo-Druckgröße', k(s.breite) + ' × ' + k(s.hoehe) + ' cm');
    });
  }

  function pruefe() {
    var probleme = [];
    if (!state.hatDatei) probleme.push('Design fehlt');
    if (anzahl() === 0) probleme.push('Mindestens eine Position wählen');
    el.blocker.innerHTML = probleme.map(function (t) { return '<li>' + t + '</li>'; }).join('');

    var eigenesPanel = root.closest('.va-panel');
    if (!(eigenesPanel && eigenesPanel.hidden)) {
      document.querySelectorAll(
        'form[action*="/cart/add"] [type=submit], form[action*="/cart/add"] .product-form__submit'
      ).forEach(function (btn) { btn.disabled = probleme.length > 0; });
    }
    return probleme.length === 0;
  }

  var form = document.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (IST_TASCHE && mengenEingabe && !aktualisiereMindestmenge()) {
        e.preventDefault();
        e.stopPropagation();
        mengenEingabe.focus();
        return;
      }
      if (!aktivesPanel()) return;
      if (!pruefe()) {
        e.preventDefault();
        e.stopPropagation();
        el.blocker.scrollIntoView({ block: 'center' });
      }
    }, true);
  }

  /* ---------- Live-Vorschau in Dawns Produktgalerie ---------- */
  function baueGalerieVorschau() {
    var productForm = root.closest('product-form');
    var sectionId = productForm && productForm.getAttribute('data-section-id');
    var gallery = sectionId && document.getElementById('MediaGallery-' + sectionId);
    var list = gallery && gallery.querySelector('ul.product__media-list');
    if (!list) return null;
    if (getComputedStyle(list).position === 'static') list.style.position = 'relative';

    var offen = false;
    var manuellGeschlossen = false;
    var aktivTab = null;
    var warAktiv = false;

    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'dtfgv-knopf';
    knopf.innerHTML = '<span aria-hidden="true">🖨️</span> DTF-Vorschau ansehen';
    knopf.hidden = true;
    list.appendChild(knopf);

    var panel = document.createElement('div');
    panel.className = 'dtfgv-panel';
    panel.hidden = true;
    var buehne = document.createElement('div');
    buehne.className = 'dtfgv-buehne';
    panel.appendChild(buehne);
    var kopf = document.createElement('div');
    kopf.className = 'dtfgv-kopfleiste';
    kopf.innerHTML = '<span class="dtfgv-marke">🖨️ DTF-Live-Vorschau</span>' +
      '<button type="button" class="dtfgv-schliessen">Live-Vorschau beenden <span aria-hidden="true">×</span></button>';
    panel.appendChild(kopf);
    var tabs = document.createElement('div');
    tabs.className = 'dtfgv-tabs';
    tabs.hidden = true;
    panel.appendChild(tabs);
    var hinweis = document.createElement('p');
    hinweis.className = 'dtfgv-hinweis';
    hinweis.textContent = 'Die Vorschau dient der Orientierung. Position, Größe und Farbwiedergabe können leicht abweichen.';
    panel.appendChild(hinweis);
    list.appendChild(panel);

    function quelle(p) { return root.querySelector('.dtf__preview[data-position="' + p + '"]'); }
    function mirrorInto(source) {
      buehne.innerHTML = '';
      if (!source) return;
      var breite = source.offsetWidth;
      var hoehe = source.offsetHeight;
      if (!breite || !hoehe) return;
      var clone = source.cloneNode(true);
      clone.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
      clone.querySelectorAll('[data-dtf-griff-init]').forEach(function (n) {
        n.removeAttribute('data-dtf-griff-init');
      });
      clone.style.width = breite + 'px';
      clone.style.height = hoehe + 'px';
      clone.style.transformOrigin = 'top left';
      var scaler = document.createElement('div');
      scaler.className = 'dtfgv-scaler';
      scaler.appendChild(clone);
      buehne.appendChild(scaler);
      var maxB = buehne.clientWidth;
      var maxH = buehne.clientHeight;
      if (!maxB || !maxH) return;
      var faktor = Math.min(maxB / breite, maxH / hoehe);
      clone.style.transform = 'scale(' + faktor + ')';
      scaler.style.width = (breite * faktor) + 'px';
      scaler.style.height = (hoehe * faktor) + 'px';
      aktiviereGroessenGriff(clone);
    }

    function schalteAndereVorschauen(aus) {
      ['.skgv-panel', '.wlgv-panel', '.skgv-knopf', '.wlgv-knopf'].forEach(function (selector) {
        list.querySelectorAll(selector).forEach(function (element) {
          if (aus) element.hidden = true;
        });
      });
    }

    function reaktiviereSichtbareStickVorschau() {
      var top = root.closest('[data-va-wrapper]');
      var embroidery = top && top.querySelector(':scope > .va-panel[data-va-panel="embroidery"]');
      var sichtbar = embroidery && !embroidery.hidden && embroidery.querySelector(':scope .va-panel:not([hidden])');
      var karte = sichtbar && sichtbar.querySelector('#stickerei-karte, #wunschlogo-karte');
      if (karte) karte.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function sync() {
      var aktiv = aktivesPanel();
      var vorhanden = AKTIV.filter(function (p) {
        return state.gewaehlt[p] && state.vorschauBereit && Boolean(quelle(p));
      });

      if (!aktiv) {
        offen = false;
        knopf.hidden = true;
        panel.hidden = true;
        if (list.dataset.dtfOverflow === '1') {
          list.style.overflow = '';
          delete list.dataset.dtfOverflow;
        }
        if (warAktiv) reaktiviereSichtbareStickVorschau();
        warAktiv = false;
        return;
      }

      warAktiv = true;
      schalteAndereVorschauen(true);
      if (!manuellGeschlossen && vorhanden.length > 0) offen = true;
      if (vorhanden.length === 0) offen = false;
      knopf.hidden = offen || vorhanden.length === 0;
      panel.hidden = !offen;
      list.style.overflow = offen ? 'hidden' : '';
      if (offen) list.dataset.dtfOverflow = '1';
      else delete list.dataset.dtfOverflow;
      if (!offen) return;

      if (!aktivTab || vorhanden.indexOf(aktivTab) === -1) aktivTab = vorhanden[0];
      tabs.hidden = vorhanden.length < 2;
      tabs.innerHTML = '';
      vorhanden.forEach(function (p) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dtfgv-tab' + (p === aktivTab ? ' ist-aktiv' : '');
        b.textContent = CFG.flaechen[p].kurz;
        b.addEventListener('click', function () { aktivTab = p; sync(); });
        tabs.appendChild(b);
      });
      mirrorInto(quelle(aktivTab));
    }

    knopf.addEventListener('click', function () { offen = true; manuellGeschlossen = false; sync(); });
    kopf.querySelector('.dtfgv-schliessen').addEventListener('click', function () {
      offen = false;
      manuellGeschlossen = true;
      sync();
    });
    window.addEventListener('resize', function () { if (offen) mirrorInto(quelle(aktivTab)); });
    var wrapper = root.closest('[data-va-wrapper]');
    if (wrapper) ['input', 'change', 'click'].forEach(function (art) {
      wrapper.addEventListener(art, function () { requestAnimationFrame(sync); });
    });
    sync();
    return { sync: sync };
  }

  var galleryVorschau = baueGalerieVorschau();

  if (IST_TASCHE && mengenEingabe) {
    ['input', 'change'].forEach(function (art) {
      mengenEingabe.addEventListener(art, function () {
        aktualisiereMindestmenge();
      });
    });
    var dtfPanel = root.closest('.va-panel');
    if (dtfPanel && window.MutationObserver) {
      new MutationObserver(function () { aktualisiereMindestmenge(); })
        .observe(dtfPanel, { attributes: true, attributeFilter: ['hidden'] });
    }
  }

  document.addEventListener('change', function (e) {
    if (!e.target.closest('variant-selects')) return;
    var neu = aktuelleFarbe();
    if (neu === CFG.farbeAktuell) return;
    CFG.farbeAktuell = neu;
    aktualisiereVorschauen();
  });

  function alles() {
    zeichnePositionen();
    zeichneGroessen();
    schreibeProperties();
    aktualisiereMindestmenge();
    pruefe();
    if (galleryVorschau) galleryVorschau.sync();
  }

  varianteSetzen();
  alles();
})();
